import { createSelector } from 'reselect'

const getState = state => state.Trainings

const getFetchTrainingsRequest = state => getState(state).fetchTrainingsRequest

const getTrainings = state => getState(state).trainings

const getTrainingsResult = createSelector(
  [getTrainings],
  trainings => (!trainings ? [] : trainings.result)
)

const getTrainingsMap = createSelector(
  [getTrainings],
  trainings => (!trainings ? {} : trainings.entities.trainings)
)

const getTrainingsList = createSelector(
  [getTrainingsResult, getTrainingsMap],
  (result, trainingsMap) => result.map(id => trainingsMap[id])
)

const getTraining = (state, id) => getTrainingsMap(state)[id]

const getSchoolOrganisationFilter = state =>
  getState(state).filters.schoolOrganisation

export {
  getTrainings,
  getTrainingsList,
  getFetchTrainingsRequest,
  getTraining,
  getSchoolOrganisationFilter
}
